import { render, staticRenderFns } from "./ArtistLibrary.vue?vue&type=template&id=2b23686f"
import script from "./ArtistLibrary.vue?vue&type=script&lang=js"
export * from "./ArtistLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports